import { useCallback, useRef } from 'react'

export const useInfiniteList = ({
  onEndOfListReached,
  enabled = true
}: {
  onEndOfListReached: () => void
  enabled?: boolean
}) => {
  const observerRef = useRef<IntersectionObserver | null>(null)

  const lastItemRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }

      if (!enabled || !node) {
        return
      }

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) {
            onEndOfListReached()
          }
        },
        { threshold: 0.5 }
      )

      observerRef.current.observe(node)
    },
    [onEndOfListReached, enabled]
  )

  return { lastItemRef }
}
